module.exports = __webpack_public_path__ + "img/grand-palm-restaurant.90dbd521.jpg";